import request from "@/lib/api/handler";

import { useAuth0 } from "@auth0/auth0-react";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { QueryKeys } from "@/queries/utils";
import {
  AdminJobCandidateDetails,
  AdminJobDetails,
} from "@/queries/admin/job-details";

export const useGetNewCandidateOpportunityMatchCriteria = (
  openingId: string,
  candidateStatusId: string,
) => {
  const qc = useQueryClient();
  const { getAccessTokenSilently } = useAuth0();

  const { mutate, isPending, error } = useMutation({
    mutationFn: async () => {
      const token = await getAccessTokenSilently();

      return request<AdminJobCandidateDetails>({
        method: "POST",
        path: `/api/admin/candidate_status/${candidateStatusId}/generate_match_criteria`,
        token,
      });
    },
    onSuccess: (data) => {
      qc.setQueryData<AdminJobDetails>(
        QueryKeys.adminJobDetails(openingId),
        (oldData) => {
          if (!oldData) {
            return oldData;
          }

          const candidates = [...oldData.candidates];
          const candidateIndex = candidates.findIndex(
            (candidate) => candidate.candidateId === data.candidateId,
          );

          if (candidateIndex !== -1 && candidates[candidateIndex]) {
            candidates[candidateIndex] = data;
            return {
              ...oldData,
              candidates,
            };
          } else {
            return {
              ...oldData,
              candidates: [...candidates, data],
            };
          }
        },
      );
    },
  });

  return {
    getNewCandidateOpportunityMatchCriteria: mutate,
    isGettingNewCandidateOpportunityMatchCriteria: isPending,
    getNewCandidateOpportunityMatchCriteriaError: error,
  };
};
